var map = {
	"./grid-reports/product-batch-movements.vue": [
		"300b",
		"product-batch-movements-vue"
	],
	"./grid-reports/product-batch-stock.vue": [
		"0710",
		"product-batch-stock-vue"
	],
	"./grid-reports/product-item-movements.vue": [
		"8720",
		"product-item-movements-vue"
	],
	"./grid-reports/product-stock-summary.vue": [
		"1258",
		"product-stock-summary-vue"
	],
	"./product-cost.vue": [
		"3b63",
		"product-cost-vue"
	],
	"./product-custom-field.vue": [
		"d8f8",
		"product-custom-field-vue"
	],
	"./product-detail.vue": [
		"8ad6",
		"product-detail-vue"
	],
	"./product-dimension.vue": [
		"8f51",
		"product-dimension-vue"
	],
	"./product-kit-components.vue": [
		"abbd",
		"product-kit-components-vue"
	],
	"./product-list.vue": [
		"3420",
		"product-list-vue"
	],
	"./product-location.vue": [
		"b4e4",
		"product-location-vue"
	],
	"./product-supplier.vue": [
		"2cd3",
		"product-supplier-vue"
	],
	"./product-unit-of-measure.vue": [
		"0930",
		"product-unit-of-measure-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3c38";
module.exports = webpackAsyncContext;